import { can } from "@qmenut/permissions";
import { noop } from "@tanstack/react-query";
import { createFileRoute, redirect } from "@tanstack/react-router";

import * as analyticsApi from "~/features/analytics/api";
import { AnalyticsPage } from "~/features/analytics/pages/analytics-page";
import { analyticsSearchSchema } from "~/features/analytics/types";
import { FEATURES } from "~/lib/features";
import { hasSelectedFeature } from "~/shared/api";

export const Route = createFileRoute("/_auth/analytics")({
  validateSearch: analyticsSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    if (!FEATURES.analytics || !can(context.roleCode, "analytics.read")) redirect({ to: "/", throw: true });
  },
  loader: async ({ context, deps }) => {
    if (!(await hasSelectedFeature(context, "analytics"))) return;
    const { queryClient, trpc } = context;
    void queryClient
      .query({ ...analyticsApi.getAnalyticsSnapshotQueryOptions({ period: deps.period, trpc }), staleTime: "static" })
      .catch(noop);
  },
  component: AnalyticsPage,
});
